import { useState, useEffect, useCallback } from "react";
/* eslint-disable */
import VideoPlayer from "./videoPlayer";
import styles from "./Broadcast.module.css";
import Spinner from "components/general/spinner/Spinner";
import AccessPrompt from "./accessPrompt/AccessPrompt";
import { Auth } from "aws-amplify";
import { BroadcastObject } from "types/broadcast";
import { Screens } from "types/general";
import { format } from "date-fns";

interface Props {
	broadcastData: BroadcastObject;
	setScreen: (v: Screens) => void;
	reload: () => void;
}
export default function BroadcastWrapper({ broadcastData, setScreen, reload }: Props) {
	const [error, setError] = useState<string>();
	const [playerError, setPlayerError] = useState<string>();
	const [startTime, setStartTime] = useState<string>();
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [vidSrc, setVidSrc] = useState<string>();
	const [user, setUser] = useState();
	const [displayAccessPrompt, setDisplayAccessPrompt] = useState({
		display: false,
		message: "",
	});

	const authenticateUser = useCallback(async () => {
		await Auth.currentAuthenticatedUser({ bypassCache: true })

			.then((user) => {
				setUser(user);

				if (broadcastData.revenue_model.toLowerCase() === "free") {
					setDisplayAccessPrompt({
						display: false,

						message: "",
					});

					if (broadcastData.status === "scheduled") {
						setStartTime(broadcastData.date);

						checkBroadcastStartLoop();
					} else {
						let accessToken = user.signInUserSession.accessToken.jwtToken;
						let idToken = user.signInUserSession.idToken.jwtToken;
						generateMuxToken(idToken, accessToken);
					}

					setIsLoading(false);
				} else {
					let passExpiration = new Date(user.attributes["custom:passEnd"]);

					if (passExpiration > new Date()) {
						setDisplayAccessPrompt({ display: false, message: "" });

						if (broadcastData.status === "scheduled") {
							setStartTime(broadcastData.date);

							checkBroadcastStartLoop();
						} else {
							// for live and archived
							let accessToken = user.signInUserSession.accessToken.jwtToken;
							let idToken = user.signInUserSession.idToken.jwtToken;
							generateMuxToken(idToken, accessToken);
						}
					} else {
						setDisplayAccessPrompt({
							display: true,
							message: "No valid pass",
						});
					}

					setIsLoading(false);
				}
			})

			.catch((err) => {
				console.log(err);
				setDisplayAccessPrompt({
					display: true,

					message: "User not logged in",
				});

				setIsLoading(false);
			});
	}, [broadcastData]);
	useEffect(() => {
		authenticateUser();
	}, [authenticateUser]);

	let checkBroadcastStartLoop = () => {
		// Begin a loop that waits for the broadcasts scheduled start time to occur.
		if (broadcastData) {
			let loop = setInterval(() => {
				let broadcastStart = new Date(broadcastData.date);

				let now = new Date();

				if (broadcastStart <= now) {
					clearInterval(loop);

					setTimeout(() => {
						setStartTime(null!);

						reload();
					}, 15000);
				}
			}, 2000);
		}
	};
	const generateMuxToken = async (idToken: string, accessToken: string) => {
		let tokenRetryCount = 0;

		const getToken = async () => {
			await fetch(
				`https://royia0wuq3.execute-api.us-east-2.amazonaws.com/prod/viewer/token`,

				{
					method: "POST",

					headers: {
						Authorization: idToken,
					},

					body: JSON.stringify({
						broadcast: broadcastData,

						token: accessToken,
					}),
				}
			)
				.then((res) => res.json())

				.then((data) => {
					// FIX FOR EDGE CASE: When user pays for pass while on this page.

					// - Takes a bit for pass to update in database.

					// - Keep calling this until valid token is returned.

					// - Throw error after retry limit is reached

					if (data.success === "false") {
						if (data.error === "Inactive Pass") {
							if (tokenRetryCount < 5) {
								setTimeout(() => {
									tokenRetryCount = tokenRetryCount + 1;

									getToken();
								}, 1000);
							} else {
								setError("An error occurred. Please try again later.");
								setIsLoading(false);
							}
						} else {
							setError("An error occurred. Please try again later.");
							setIsLoading(false);
						}
					} else {
						if (data.url) {
							setVidSrc(data.url);
							setIsLoading(false);
						} else {
							setError("An error occurred. Please try again later.");
						}
					}
				})

				.catch(() => {
					setError("An error occurred. Please try again later.");

					setIsLoading(false);
				});
		};

		getToken();
	};

	return (
		<section className={styles.broadcastVideo}>
			<div className={styles.videoFrame}>
				<div className={styles.playerWrapper}>
					{!isLoading ? (
						<>
							{displayAccessPrompt.display ? (
								<AccessPrompt message={displayAccessPrompt.message} setScreen={setScreen} />
							) : (
								<>
									{error ? (
										<div className={styles.errorScreen}>
											<div className={styles.overlay}>
												<p>{error}</p>
											</div>
										</div>
									) : (
										<>
											{startTime ? (
												<div className={styles.countDownScreen}>
													<p className="text-light">
														This broadcast is scheduled to start on {format(new Date(startTime), "MMMM dd")} at{" "}
														{format(new Date(startTime), "hh:mm a")}
													</p>
												</div>
											) : null}

											{vidSrc ? (
												<>
													<VideoPlayer
														src={vidSrc}
														broadcastData={broadcastData}
														user={user}
														setPlayerError={() => {
															setPlayerError("An error occurred. Please try again later.");
														}}
													/>

													{playerError ? (
														<div className={styles.errorScreen}>
															<div className={styles.overlay}>
																<p>{playerError}</p>
															</div>
														</div>
													) : null}
												</>
											) : null}
										</>
									)}
								</>
							)}
						</>
					) : (
						<div className={styles.loadingScreen}>
							<Spinner color="255, 255, 255" />
						</div>
					)}
				</div>
			</div>
		</section>
	);
}
